import { mapGetters, mapActions } from 'vuex';
export default {
  computed: {
    ...mapGetters({
      musicArr: 'addSoundtrack/getMusicArr',
      dubbingArr: 'addSoundtrack/getDubbingArr',
      SelectScenes_Msg: 'SelectScenes_Msg',
      TOOL: 'TOOL'
    })
  },
  methods: {
    ...mapActions({
      setRecent: "resources/setRecent",
    }),
    findMin(arr) {
      let minData = arr[0];
      arr.forEach(v => {
        if (v.timeSlot[0] < minData.timeSlot[0]) {
          minData = v;
        }
      });
      return minData;
    },
    setMusic(item) {
      let sound = this.findMin(this.musicArr);
      let toolDur = this.TOOL.getDuration() / 1000;
      let start = 0;
      let end = start + Math.min(item.duration, toolDur);
      if (sound && sound.timeSlot[0] < 0.2) {
        this.$store.commit("addSoundtrack/updateMusic", {
          music: {
            title: item.title,
            resourceId: item.id,
            id: item.id,
            "type": "2",
            "fileType": item.fileType,
            "url": item.url,
            "cut": [0, item.duration],
            timeSlot: [start, end]
          },
          index: 0
        });
        this.$message({
          message: '声音添加成功！请到“声音与字幕”处编辑管理。',
          type: "success",
        });
        this.setRecentDatas(item.id)
        return;
      }
      if (sound && sound.timeSlot[0] >= 0.2 && sound.timeSlot[0] < end) {
        end = sound.timeSlot[0];
      }

      this.$store.commit("addSoundtrack/addMusic", {
        music: {
          title: item.title,
          resourceId: item.id,
          id: item.id,
          "type": "2",
          "fileType": item.fileType,
          "url": item.url,
          "cut": [0, item.duration],
          timeSlot: [start, end]
        },
        index: 0
      });
      this.$message({
        message: '声音添加成功！请到“声音与字幕”处编辑管理。',
        type: "success",
      });
      this.setRecentDatas(item.id)
    },
    setRecentDatas(id) {
      this.setRecent({ type: "sound", id: id }).then((res) => {
        console.log("提交最近使用", res);
      });
    },
    setDub(item) {
      let sound = this.findMin(this.dubbingArr);
      let toolDur = this.TOOL.getDuration() / 1000;
      let start = 0;
      let end = start + Math.min(item.duration, toolDur);
      if (sound && sound.timeSlot[0] < 0.2) {
        this.$message({
          message: '添加失败，当前位置已有声音，可进入“声音与字幕”调整修改。',
          type: "error",
        });
        return;
      }
      if (sound && sound.timeSlot[0] >= 0.2 && sound.timeSlot[0] < end) {
        end = sound.timeSlot[0];
      }

      this.$store.commit("addSoundtrack/addDubbing", {
        dubbing: {
          title: item.title,
          resourceId: item.id,
          id: item.id,
          "type": "1",
          "fileType": item.fileType,
          "url": item.url,
          "cut": [0, item.duration],
          timeSlot: [start, end]
        },
        index: 0
      });
      this.$message({
        message: '声音添加成功！请到“声音与字幕”处编辑管理。',
        type: "success",
      });
    },
    setDubInScene(item) {
      let sceneTime = 0;
      this.TOOL.sprites.some((v, i) => {
        let flag = this.SelectScenes_Msg === v;
        if (flag) {
          return flag;
        } else {
          sceneTime = sceneTime + v.duration / 1000;
        }
      });
      let sound;
      let slotIndex = 0;
      this.dubbingArr.some((v, i, arr) => {
        let d = v.timeSlot[0] - sceneTime
        // if (!sound && d >= 0) {
        //   sound = v;
        //   slotIndex = i;
        // }
        // if (sound && d > 0 && d < sound.timeSlot[0] - sceneTime) {
        //   sound = v;
        //   slotIndex = i;
        // }
        if (sceneTime === 0) {
          slotIndex = 0;
          return true;
        }
        if (sceneTime >= v.timeSlot[0] && sceneTime < v.timeSlot[1]) {
          slotIndex = i;
          return true;
        }
        let prev = arr[i - 1];
        let prevEnd = prev ? prev.timeSlot[1] : 0;
        if (v && prevEnd < sceneTime && v.timeSlot[0] > sceneTime) {
          slotIndex = i;
          return true;
        }

        slotIndex++;
      });
      sound = this.dubbingArr[slotIndex];
      let sceneDur = this.SelectScenes_Msg.duration / 1000;
      let start = sceneTime;
      let end = Math.min(start + item.duration, start + sceneDur);
      if (sound && sound.timeSlot[0] - sceneTime < 0.2) {
        this.$message({
          message: '添加失败，当前位置已有声音，可进入“声音与字幕”调整修改。',
          type: "error",
        });
        return;
      }
      if (sound && sound.timeSlot[0] - sceneTime >= 0.2 && sound.timeSlot[0] < end) {
        end = sound.timeSlot[0];
      }

      this.$store.commit("addSoundtrack/addDubbing", {
        dubbing: {
          title: item.title,
          resourceId: item.id,
          id: item.id,
          "type": "1",
          "fileType": item.fileType,
          "url": item.url,
          "cut": [0, item.duration],
          timeSlot: [start, end]
        },
        index: slotIndex
      });
      this.$message({
        message: '声音添加成功！请到“声音与字幕”处编辑管理。',
        type: "success",
      });
    },
    setSceneTiming(willSetState) {
      let sceneTime = 0;
      this.TOOL.sprites.some((v, i) => {
        let flag = this.SelectScenes_Msg === v;
        if (flag) {
          return flag;
        } else {
          sceneTime = sceneTime + v.duration / 1000;
        }
      });
      let slotIndex = 0;
      this.dubbingArr.some((v, i, arr) => {
        if (sceneTime === 0) {
          slotIndex = 0;
          return true;
        }
        if (sceneTime >= v.timeSlot[0] && sceneTime < v.timeSlot[1]) {
          slotIndex = i;
          return true;
        }
        let prev = arr[i - 1];
        let prevEnd = prev ? prev.timeSlot[1] : 0;
        if (v && prevEnd < sceneTime && v.timeSlot[0] > sceneTime) {
          slotIndex = i;
          return true;
        }

        slotIndex++;
      });

      let sound = this.dubbingArr[slotIndex];
      if (!willSetState && sound && sound.timeSlot[0] - sceneTime < 0.2) {
        this.$message({
          message: '当前位置已有声音，可进入“声音与字幕”调整修改。',
          type: "error",
        });
        return;
      }
      let toolDur = this.TOOL.getDuration() / 1000;
      let end = sound ? sound.timeSlot[0] : toolDur;

      this.$store.commit("addSoundtrack/setSoundtrackState", {
        state: true,
        type: 'dub',
        start: sceneTime,
        end: end,
        index: slotIndex,
        operation: "add",
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/rightnav/slide/addSound.js